import React from 'react';
import InnerPageBanner from '../../../components/InnerPageBanner';
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    CardMedia,
    CardContent,
    Button
} from '@mui/material';
import { Link } from 'react-router-dom';

// Import Cobblestone images
import cobbStone2 from '../../../assets/images/Cobb stone Hand Cut Natural1.jpeg';
import cobbStone3 from '../../../assets/images/Machine Cut 3line Dressing1.jpeg';
import cobbStone1 from '../../../assets/images/CobblestoneMachineCut1.jpeg';
import cobbStone4 from '../../../assets/images/Machine Cut Fleming1.jpeg';
import cobbStone5 from '../../../assets/images/Machine Cut 2line Dressing1.jpeg';
import cobbStone6 from '../../../assets/images/Full Box Cut Natural Face1.jpeg';
import CobbleStoneBanner from './CobbleStoneBanner';


const CobbleStone = () => {

    const varieties = [
        {
            id: "machine-cut-natural-face",
            title: "Machine Cut Natural Face",
            image: cobbStone1
        },
        {
            id: "hand-cut-natural",
            title: "Hand Cut Natural",
            image: cobbStone2
        },
        {
            id: "machine-cut-3line-dressing",
            title: "Machine Cut 3Line Dressing (Bush Hammer)",
            image: cobbStone3
        },
        {
            id: "machine-cut-fleming-face",
            title: "Machine Cut Fleming Face",
            image: cobbStone4
        },
        {
            id: "machine-cut-2line-dressing",
            title: "Machine Cut 2Line Dressing",
            image: cobbStone5
        },
        {
            id: "full-edge-box-cut",
            title: "Full Edge Box Cut",
            image: cobbStone6
        }
    ];

    return (
        <Box>
            <CobbleStoneBanner />
            <Container sx={{ py: 5 }}>
                <Box sx={{ backgroundColor: "#f5f5f5", py: { xs: 4, md: 6 }, px: { xs: 2, md: 4 } }}>
                    {/* HERO SECTION */}
                    <Box
                        sx={{
                            backgroundColor: "#eee",
                            p: { xs: 3, sm: 5, md: 6 },
                            textAlign: "center",
                            mb: { xs: 5, md: 8 },
                            borderRadius: 2
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: 26, sm: 32, md: 36 }
                            }}
                        >
                            Cobble Stone
                        </Typography>

                        <Box sx={{ width: 50, height: 3, backgroundColor: "#1abc9c", mx: "auto", my: 2 }} />

                        <Typography sx={{ mt: 3, fontSize: { xs: 13, md: 14 } }} >
                            <strong>Available Color</strong><br />
                            Grey (White)<br />
                            Jet Black<br />
                            Yellow<br />
                            Pink (Red)
                        </Typography>

                        <Typography sx={{ mt: 3, fontSize: { xs: 13, md: 14 } }} >
                            <strong>Available Sizes</strong><br />
                            4"x4" Inches 100x100mm 10x10cm<br />
                            6"x6" Inches 150x150mm 15x15cm<br />
                            8"x8" Inches 200x200mm 20x20cm<br />
                            12"x12" Inches 300x300mm 30x30cm<br />
                            Thickness 2"-3" Inches 50x70mm 5to7
                        </Typography>
                    </Box>

                    {/* VARIETIES SECTION */}
                    <Typography
                        sx={{
                            fontWeight: 700,
                            mb: 1,
                            fontSize: { xs: 20, md: 24 }
                        }}
                    >
                        Available Varieties
                    </Typography>

                    <Box
                        sx={{
                            width: 40,
                            height: 3,
                            backgroundColor: "#1abc9c",
                            mb: 4
                        }}
                    />

                    <Grid container spacing={4}>
                        {varieties.map((item, index) => (
                            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                                <Card
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        height: "100%",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                                        borderRadius: 2,
                                        borderBottom: "3px solid #1abc9c",
                                        overflow: "hidden",
                                        transition: "0.3s",
                                        "&:hover": {
                                            transform: { md: "translateY(-6px)" },
                                            boxShadow: "0 8px 24px rgba(0,0,0,0.12)"
                                        },
                                        "&:hover img": {
                                            transform: { md: "scale(1.05)" }
                                        }
                                    }}
                                >
                                    {/* Fixed Image Area */}
                                    <CardMedia
                                        component="img"
                                        image={item.image}
                                        alt={item.title}
                                        sx={{
                                            height: 220,
                                            objectFit: "cover",
                                            transition: "0.4s"
                                        }}
                                    />

                                    {/* Content */}
                                    <CardContent
                                        sx={{
                                            flexGrow: 1,
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textAlign: "center",
                                            p: 3
                                        }}
                                    >
                                        <Button
                                            component={Link}
                                            to={`/cobble-stone/${item.id}`}
                                            variant="contained"
                                            sx={{
                                                backgroundColor: "#1abc9c",
                                                textTransform: "none",
                                                fontSize: "15px",
                                                padding: "4px 16px",
                                                minHeight: "32px",
                                                width: "fit-content",
                                                mb: 2,
                                                "&:hover": {
                                                    backgroundColor: "#16a085"
                                                }
                                            }}
                                        >
                                            Cobble Stone
                                        </Button>

                                        <Typography sx={{ fontWeight: 500, fontSize: '1rem' }}>
                                            {item.title}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};

export default CobbleStone;